import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { XCircle, CheckCircle2, ArrowRight } from 'lucide-react';
const comparisons = [{
  before: 'Cada noche peleando por la tarea',
  after: 'Rutina de tareas en bloques que el mismo hijo sostiene'
}, {
  before: 'Crisis que escalan sin saber cómo pararlas',
  after: 'Protocolo de 4 pasos para manejar cualquier explosión'
}, {
  before: 'El colegio te da vueltas en cada reunión',
  after: 'Carta lista para pedir adaptaciones con respaldo legal'
}, {
  before: 'La obra social te dice que no y no sabés qué hacer',
  after: 'Modelo de reclamo formal que la obra social no puede ignorar'
}, {
  before: 'Estrategias sueltas de Instagram que no se sostienen',
  after: 'Sistema completo con herramientas que se aplican desde hoy'
}, {
  before: 'Sin saber si lo estás haciendo bien',
  after: 'Plan de 30 días con pasos claros y progresión visible'
}, {
  before: 'Agotada, con culpa y sin recursos propios',
  after: 'Tomo completo para que vos también puedas sostenerte'
}, {
  before: 'Meses sin cambios reales',
  after: 'Primeros resultados en 21 días de aplicación consistente'
}];
export function Comparison() {
  return <section className="py-12 md:py-20 bg-[#FBF7F0]" data-id="element-69">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <SectionHeader title="LA REALIDAD" subtitle="¿Cuánto cuesta NO tenerlo?" data-id="element-71" />

        <div className="bg-white rounded-2xl md:rounded-3xl shadow-sm border border-[#1E2A4A]/10 overflow-hidden" data-id="element-72">
          <div className="grid grid-cols-2 bg-[#1E2A4A] text-white p-4 md:p-6 text-center font-bold text-sm md:text-xl" data-id="element-73">
            <div data-id="element-74">Sin el sistema</div>
            <div data-id="element-75">Con el sistema</div>
          </div>

          <div className="divide-y divide-[#1E2A4A]/5" data-id="element-76">
            {comparisons.map((item, i) => <motion.div key={i} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className="grid grid-cols-2 p-4 md:p-6 gap-3 md:gap-4 items-center hover:bg-gray-50 transition-colors" data-id="element-77">
                <div className="flex items-start gap-2 md:gap-3 text-red-700/80 pr-2 md:pr-8 relative" data-id="element-78">
                  <XCircle className="shrink-0 mt-0.5 text-red-500 w-4 h-4 md:w-5 md:h-5" data-id="element-79" />
                  <span className="text-xs md:text-base font-medium leading-snug" data-id="element-80">
                    {item.before}
                  </span>
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 hidden md:block text-gray-300" data-id="element-81">
                    <ArrowRight size={24} data-id="element-82" />
                  </div>
                </div>
                <div className="flex items-start gap-2 md:gap-3 pl-2 md:pl-8" data-id="element-83">
                  <CheckCircle2 className="shrink-0 mt-0.5 text-[#8A9A86] w-4 h-4 md:w-5 md:h-5" data-id="element-84" />
                  <span className="text-xs md:text-base font-bold text-[#1E2A4A] leading-snug" data-id="element-85">
                    {item.after}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}